/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type Pillar2AuthType = (typeof Pillar2AuthType)[keyof typeof Pillar2AuthType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Pillar2AuthType = {
    None: 'None',
    Oauth2: 'Oauth2',
    Dac: 'Dac',
} as const;
